import { useUploader, UploadSource, UploadType } from '@buffer-mono/uploader'
import AppActionCreators from '../../action-creators/AppActionCreators'
import ComposerActionCreators from '../../action-creators/ComposerActionCreators'
import NotificationActionCreators from '../../action-creators/NotificationActionCreators'
import { NotificationScopes } from '../../AppConstants'
import AppDispatcher from '../../dispatcher'
import ModalActionCreators from '../../shared-components/modal/actionCreators'
import { ActionTypes } from '../../state/ActionTypes'
import { useAppSelector } from '~publish/legacy/store/index'
import { selectUserId } from '~publish/legacy/user/selectors'
import { selectCurrentOrganizationId } from '~publish/legacy/organizations/selectors'

export const useUpdateInstagramThumbnail = () => {
  const userId = useAppSelector(selectUserId)
  const organizationId = useAppSelector(selectCurrentOrganizationId)
  const uploader = useUploader({
    id: UploadType.postAsset,
    userId,
    organizationId,
  })

  const updateThumbnail = ({
    imageFile,
    draftId,
    videoTitle,
  }: {
    imageFile: File
    draftId: string
    videoTitle?: string
  }): void => {
    const video = document.getElementById('thumbnailVideo') as HTMLVideoElement

    uploader
      .upload([imageFile], {
        source: UploadSource.filePicker(),
      })
      .then((results) => results.successful[0])
      .then((result) => {
        ComposerActionCreators.updateDraftVideoTitle(draftId, videoTitle)
        AppDispatcher.handleViewAction({
          actionType: ActionTypes.COMPOSER_UPDATE_INSTAGRAM_DRAFT_THUMBNAIL,
          id: draftId,
          thumbOffset: video.currentTime * 1000,
          thumbnail: result.uploadURL,
        })

        // allows you to add to queue once upload is complete
        AppActionCreators.setThumbnailLoading(false)
        ModalActionCreators.closeModal()
      })
      .catch((err) => {
        uploader.reportError(err, imageFile)
        NotificationActionCreators.queueError({
          scope: NotificationScopes.FILE_UPLOAD,
          message:
            'Uh oh! It looks like we had an issue saving the thumbnail. Up for trying again?',
        })
        AppActionCreators.setThumbnailLoading(false)
        ModalActionCreators.closeModal()
      })
  }

  return { updateThumbnail }
}
